define.alias("shared/utils/compare-strings", "calendar/utils/compare-strings");